module.exports = __webpack_public_path__ + "img/monocycle-back.97a28b56.jpg";